import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    Button,
} from "@chakra-ui/react";
import { useState } from "react";

import AddAddressFlow from "./AddAddressFlow";
import AddressList from "./AdressesList";

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

const DeliveryAddressModal = ({ isOpen, onClose }: Props) => {
    const [adding, setAdding] = useState(false);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    {adding ? "Add delivery address" : "Choose delivery address"}
                </ModalHeader>
                <ModalBody>
                    {adding ? (
                        <AddAddressFlow onDone={() => setAdding(false)} />
                    ) : (
                        <>
                            {/* <AddressList onSelect={onClose} /> */}
                            <Button
                                mt={4}
                                w="full"
                                colorScheme="teal"
                                onClick={() => setAdding(true)}
                            >
                                + Add new address
                            </Button>
                        </>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default DeliveryAddressModal;
